// extracted by mini-css-extract-plugin
export default {"caption":"Text_caption__1X4-X","primary":"Text_primary__fAwpe"};